import React, { Component } from "react";
import { connect } from "react-redux";
import linkedin from "../../images/linked-in-icon.svg";
import facebook from "../../images/facebook-icon.svg";
class Footer extends Component {
  constructor(props) {
    super(props);
  }
  render() {
    return (
      <div className="outer_application_form">
        <footer>
          {/* ----- New Footer ----- */}
          <div className="nvam-footer-wrapper">
            <div className="wrapper">
              <div className="row d-flex flex-center">
                <div className="">
                  <h4>North Valley Tree Service</h4>
                  <div className="row">
                    <div className="col-md-12">
                      {/* <h5>Chico Facility</h5> */}
                      <p>
                        3882 Esplanade,
                        <br /> Chico, CA 95973
                      </p>

                      <p>
                        Phone:{" "}
                        <a href="tel:530-893-9649" class="tel">
                          530-893-9649{" "}
                        </a>
                        <span> (Hours: Mon-Fri, 9am-4pm) </span>
                      </p>

                      <p>
                        Fax:{" "}
                        <a href="tel:530-893-9650" class="tel">
                          530-893-9650
                        </a>
                      </p>
                    </div>
                  </div>

                  <div className="nvam-footer-social-wrap">
                    {/* <a href="#" className="nvam-social-item" target="_blank">
                      <img src={linkedin} alt="" />
                    </a> */}
                    <a href="https://www.facebook.com/northvalleytreeservice" className="nvam-social-item" target="_blank">
                      <img src={facebook} alt="" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
            <p className="nvam-foot-copyright">
              Copyright © {new Date().getFullYear()} North Valley Tree Service and its licensors. All rights reserved.
            </p>
          </div>
        </footer>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return state;
}
const connectedApp = connect(mapStateToProps)(Footer);
export { connectedApp as Footer };
